var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loadingMce)?_c('vue2-tinymce-editor',{ref:"tinymceEditor",attrs:{"inline":true,"options":_vm.options},model:{value:(_vm.localTextContent),callback:function ($$v) {_vm.localTextContent=$$v},expression:"localTextContent"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }